<template>
  <div class="foot-box">
    <div class="foot">
      <div class="left-box">
        <div class="logo-box">
          <img class="logo-icon" src="@/assets/images/nav/large-logo.png" alt />
          <span>舟道学院</span>
        </div>
        <div class="more-text">专注教育平台服务</div>
      </div>
      <div class="right-box">
        <div class="box-item" v-for="menu of menuList">
          <div class="title">{{ menu.title }}</div>
          <div class="menu-item" v-for="item of menu.list" @click="chooseMenu(menu.type, item)">{{ item.name }}</div>
        </div>
        <div class="box-right">
          <img class="person-qrcode" src="~@/assets/images/home/qrcode/person-qrcode.jpg" alt />
          <div class="title">联系我们</div>
          <div class="phone">
            <svg class="icon-svg icon-phone">
              <use xlink:href="#icon-dianhua" />
            </svg>
            <span>137 6516 8933</span>
          </div>
          <div class="phone">
            <svg class="icon-svg icon-phone">
              <use xlink:href="#icon-dianhua" />
            </svg>
            <span>wanglinrui@arktao.cn</span>
          </div>
          <!-- 公安备案 -->
          <div>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52990002000053"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#fff">
              <img :src="publicImage" style="float:left;" />
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">
                贵公网安备52990002000053号
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="popup-box" v-if="qrcode">
      <div class="blackscreen" @click="qrcode = ''"></div>
      <div class="box-content">
        <img :src="qrcode" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'foot',
  data() {
    return {
      menuList: [
        {
          title: '快速入口',
          type: 'link',
          list: [
            // { name: '舟道', url: 'https://www.arktao.com' },
            { name: '超级教案', url: 'https://www.lessonplan.cn' },
            { name: '元习', url: 'https://yuanxi.online' }
          ]
        }, {
          title: '公众号',
          type: 'qrcode',
          list: [
            { name: '舟知' },
            { name: '双创思维' },
            { name: '超级教案Lessonplan' },
            { name: '元习' }
          ]
        },
      ],

      publicImage: require('@/assets/images/public_security.png'),

      qrcode: ''
    }
  },
  methods: {
    //选择菜单
    chooseMenu(type, item) {
      if (type == 'link') window.open(item.url);
      else this.qrcode = require(`@/assets/images/home/qrcode/${item.name}.jpg`);
    }
  }
}
</script>
<style scoped lang="scss">
@import "./foot.scss";
</style>